export default {
  'Screenshot': 'Снимок экрана',
}